/**
 * Adaptadores de "carga vinculada" para a tela de SQLs de Integração.
 *
 * A listagem de /admin/sqls-erp devolve a carga vinculada em `model.tarefa`
 * (relação serializada via toArray — snake_case, sem passar pelo TarefaTransformer).
 * Aqui normalizamos esse formato para o shape esperado pelos utilitários de
 * `helpers/cargasSaude.js` (`ultimaSincronizacao`, `apenasLeitura`, ...), de modo
 * que a noção de "saúde" seja a mesma da tela de Cargas.
 */
import { statusOf } from '@/helpers/cargasSaude';

/**
 * Normaliza a carga vinculada de uma view (ou null quando não há carga).
 * Tolerante aos dois formatos possíveis da última sincronização:
 *  - cru (toArray): `ultima_sincronizacao` com `sucesso` 0/1, `dthora_fim`, `mensagem_retorno`
 *  - transformer:  `ultimaSincronizacao` com `sucesso` bool, `fim`, `msg`
 */
export function cargaDe(model) {
  const tarefa = model && model.tarefa;
  if (!tarefa) {
    return null;
  }

  const u = tarefa.ultima_sincronizacao || tarefa.ultimaSincronizacao || null;

  return {
    ativo: tarefa.ativo,
    apenasLeitura: tarefa.readonly ? 1 : 0,
    ultimaSincronizacao: u
      ? {
          id: u.id,
          sucesso: !!(u.sucesso === true || +u.sucesso === 1),
          fim: u.fim || u.dthora_fim || null,
          inicio: u.inicio || u.dthora_inicio || null,
          msg: u.msg || u.mensagem_retorno || '',
        }
      : null,
  };
}

/**
 * A view tem carga vinculada ATIVA cuja última sincronização falhou.
 * Delegado a `statusOf` para usar exatamente a mesma régua da tela de Cargas.
 */
export function cargaQuebrada(model, carga = cargaDe(model)) {
  return statusOf(carga) === 'quebrada';
}

/**
 * Filtro de status (chip) sobre uma view. "ativas/inativas" referem-se ao campo
 * `ativo` da própria view; "quebrada" usa a saúde da carga vinculada.
 * `carga` pode vir pré-normalizada (evita realocar objetos a cada filtro).
 */
export function matchFilterView(model, chave, carga = cargaDe(model)) {
  switch (chave) {
    case 'ativas':
      return +model.ativo === 1;
    case 'inativas':
      return +model.ativo !== 1;
    case 'quebrada':
      return cargaQuebrada(model, carga);
    case 'todas':
    default:
      return true;
  }
}
